var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/icons/Highlight.tsx"; // This file was auto-generated using scripts/generate-icons.js
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Icon generated from highlight.svg
 */
export default function HighlightIcon(props) {
  return _jsxDEV("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    "data-component": "HighlightIcon",
    ...props,
    children: _jsxDEV("g", {
      fill: "none",
      "fill-rule": "evenodd",
      children: [_jsxDEV("path", {
        d: "M0 0h16v16H0z"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 15H1h11zm-.5-6v2l-1 1v-2l1-1zm.5-7v6h-2V2h2zm0-1h-2 2zm0 8h-2 2z"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=Highlight.js.map